import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/EmailConfirmation.css';

const EmailConfirmation = () => {
  const [isConfirmed, setIsConfirmed] = useState(false);
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const checkEmailConfirmation = async () => {
      await refreshUser();
      if (user && user.email_confirmed_at) {
        setIsConfirmed(true);
        setTimeout(() => navigate('/'), 3000); // Redirect to home page after 3 seconds
      }
    };

    const intervalId = setInterval(checkEmailConfirmation, 5000); // Check every 5 seconds

    return () => clearInterval(intervalId);
  }, [user, navigate, refreshUser]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md">
        <div className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          <h2 className="text-2xl font-bold mb-4 text-center">Email Confirmation</h2>
          {isConfirmed ? (
            <p className="mb-4 text-center text-green-600">
              Your email has been confirmed! Redirecting to the main app...
            </p>
          ) : (
            <>
              <p className="mb-4 text-center">
                Please check your inbox for a confirmation email. Click the link in the email to verify your account.
              </p>
              <p className="text-center">
                <Link to="/auth" className="text-blue-500 hover:text-blue-700">
                  Return to login
                </Link>
              </p>
              <p className="text-xs text-gray-500 mt-4 text-center">
                <span className="tooltip">
                  Why confirm email?
                  <span className="tooltiptext">
                    By confirming your email, we ensure that you have access to account at all times, through password resets, etc. Typos happen; we've seen enough support cases to know that even the thinnest fingers sometimes miskey.
                  </span>
                </span>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailConfirmation;